import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'components/ui/table';
import { JobRoleDto } from 'types/jobRoles';
import { NamedEntityMinDto } from 'types/other';
import { t } from 'utils/getTranslations';

interface PersonRow {
    employee: NamedEntityMinDto;
    jobRole: JobRoleDto | null;
    hourlyPrice: string | number | null;
}

interface Props {
    rows: PersonRow[];
    currencyTypeCode?: string | null;
}

const isPriced = (price: PersonRow['hourlyPrice']): boolean => price !== null && price !== undefined && price !== '';

/** The people of one employee-priced case list, read-only: the colleague, the role they hold today and the price. */
export function CasePeopleRates({ rows, currencyTypeCode }: Props): JSX.Element {
    if (rows.length === 0) {
        return <div className="text-grey-500 py-1 text-xs">{t('pricelists.employee.no-prices')}</div>;
    }
    const sorted = rows.toSorted((a, b) => a.employee.name.localeCompare(b.employee.name));
    return (
        <Table className="text-xs">
            <TableHeader>
                <TableRow>
                    <TableHead className="h-7 px-0">{t('pricelists.case-follow.colleague')}</TableHead>
                    <TableHead className="h-7">{t('pricelists.case-follow.job-role')}</TableHead>
                    <TableHead className="h-7 px-0 text-end">{t('pricelists.case-follow.price')}</TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {sorted.map((row) => (
                    <TableRow key={row.employee.id}>
                        <TableCell className="px-0 py-1 break-words whitespace-normal">{row.employee.name}</TableCell>
                        <TableCell className="text-grey-600 py-1 break-words whitespace-normal">
                            {row.jobRole ? row.jobRole.internalName || row.jobRole.name : ''}
                        </TableCell>
                        <TableCell className="px-0 py-1 text-end tabular-nums">
                            {isPriced(row.hourlyPrice) ? (
                                `${currencyTypeCode ? `${currencyTypeCode} ` : ''}${row.hourlyPrice}`
                            ) : (
                                <span className="text-muted-foreground">{t('pricelists.employee.no-price')}</span>
                            )}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}
